<template>
  <section>
    <section>
      <modal-history-funil :callCheckRequest="callCheckRequest"/>
      <modal-default modal-title="Envio em massa" modal-id="massShipping">
        <template>
          <div class="col-md-12 list-company">
            <div v-for="(item, index) in listItemsSelect" :key="index" :id="item.id" class="items-list">
              <span>{{ item.name }}</span>
              <button class="remove-item" @click="removeItem(item)">
                <ion-icon name="close-outline"></ion-icon>
              </button>
            </div>
          </div>
          <div class="col-md-12">
            <input-autocomplete @valueAutocomplete="value => autocompleteContent = value"
                                :input-error="validateSend.listItemsSelect" value-return-obj="true"
                                clear-input-on-select="true" :value="loadedCompanies" margin-bottom="8px"/>
            <input-checkbox :is-checked="showAllCompany" col="0" label="Pesquisar desativadas"
                            @valueCheckbox="value => showAllCompany = value"/>
          </div>
          <input-select is-required="true" :input-error="validateSend.companiesNameList" col="6"
                        @selectedOption="value => massAction = value" :options="listAction" label="Ação"/>
          <input-textarea @contentTextarea="value => textAreaContent = value" col="12"
                          placeholder="Digite seu comentário aqui" label="Enviar comentário"/>
          <btn-search @emit-click="sendMassShipping()" have-loading="true" :loading="loadingSend" label="Enviar"
                      col="3"/>
        </template>
      </modal-default>
      <!-- top-menu -->
      <top-menu/>
      <!-- funnel -->
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <box-list-filter v-if="!loadingList" title="Funil">
              <p><a v-on:click="openHistory()">Visualizar Histórico de Alteração</a></p>
              <template>
                <input-text col="3" @contentText="value => dataSearch.companyName = value" type="text"
                            placeholder="Digite o nome" label="Nome da empresa"/>
                <input-select col="3" @selectedOptionString="value => dataSearch.tag = value" name-only-string="true"
                              :options="listTag" label="Tag"/>
                <input-select col="3" @selectedOptionString="value => dataSearch.owner = value" name-only-string="true"
                              :options="dataSelectResponsibles" label="Responsável"/>
                <input-select col="3" @selectedOption="value => dataSearch.isScheduled = value" :options="onlySchedule"
                              label="Apenas agendados?"/>
                <input-select col="3" @selectedOption="value => dataSearch.getNotactive = value"
                              :options="disableCompany" label="Empresas Desativadas?"/>
                <input-select col="3" @selectedOptionString="value => dataSearch.profileClient = value"
                              name-only-string="true" :options="selectProfilesClient" label="Perfil do cliente:"/>
                <input-select col="3" @selectedOption="value => dataSearch.taskActivities = value"
                              :options="listTaskActivities" label="Nome da atividade"/>
                <input-select col="3" @selectedOption="value => dataSearch.taskStatus = value" :options="statusActivity"
                              label="Status da atividade"/>
                <btn-custom @emit-click="searchFunnel()" label="Pesquisar" col="6"/>
                <btn-custom @emit-click="openModalMassShipping()" label="Enviar em massa" btn-color="green" col="6"
                            which-side="right"/>
              </template>
            </box-list-filter>

            <!-- Table -->
            <box-listing v-if="!loadingList" title="" empty-state="" columns-list-header="">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <!-- Onboarding -->
                <div class="col-xs-12 col-sm-6 col-md-3 box-pipe">
                  <div class="title-box custom-scrollbar">
                    <p>Onboarding <span>({{ dataList.stage1.length }})</span></p>
                  </div>

                  <draggable :draggable="false" class="list-group" :list="dataList.stage1" group="people"
                             @change="logStage1">
                    <div class="list-group-item" v-for="(element, index) in searchList1" :key="element.id"
                         v-bind:style="{'background': element.color}">
                      <a v-bind:href="'/empresa-detalhes-funil/' + element.pipelineId + '/' + element.id"
                         target="_blank">
                        <p class="company-name" v-bind:title="element.name">{{ element.name | limitTo(30) }}<span><span
                          title="Total de dias no sistema">{{ element.totalDaysCreated }}</span> - <span
                          title="Nome do Proprietário">{{ element.ownerName }}</span></span></p>
                        <p v-if="element.lastUpdated" class="last-update" title="Ultima atualização">
                          {{ element.lastUpdated | dateFunil }}</p>
                        <i v-if="element.hasAcitivty" v-bind:style="element.lastUpdated ? 'top: 40px;' : 'top: 12px;' "
                           class="fa fa-clock-o clock-time" aria-hidden="true">
                          <span class="activityDate" v-if="element.activityDate">
                            {{ element.activityDate }} - </span>
                        </i>

                        <div class="box-tag">
                          <span v-for="t in element.tags" class="tag"
                                v-bind:style="{'background': t.color}">{{ t.value }}</span>
                        </div>
                      </a>
                    </div>
                  </draggable>
                </div>
                <!-- Acompanhamento -->
                <div class="col-xs-12 col-sm-6 col-md-3 box-pipe">
                  <div class="title-box custom-scrollbar">
                    <p>Acompanhamento <span>({{ dataList.stage2.length }})</span></p>
                  </div>

                  <draggable :draggable="false" class="list-group" :list="dataList.stage2" group="people"
                             @change="logStage2">
                    <div class="list-group-item" v-for="(element, index) in searchList2" :key="element.id"
                         v-bind:style="{'background': element.color}">
                      <a v-bind:href="'/empresa-detalhes-funil/' + element.pipelineId + '/' + element.id"
                         target="_blank">
                        <p class="company-name" v-bind:title="element.name">{{ element.name | limitTo(30) }}<span><span
                          title="Total de dias no sistema">{{ element.totalDaysCreated }}</span> - <span
                          title="Nome do Proprietário">{{ element.ownerName }}</span></span></p>
                        <p v-if="element.lastUpdated" class="last-update" title="Ultima atualização">
                          {{ element.lastUpdated | dateFunil }}</p>
                        <i v-if="element.hasAcitivty" v-bind:style="element.lastUpdated ? 'top: 40px;' : 'top: 12px;' "
                           class="fa fa-clock-o clock-time" aria-hidden="true">
                          <span class="activityDate" v-if="element.activityDate">
                            {{ element.activityDate }} - </span>
                        </i>

                        <div class="box-tag">
                          <span v-for="t in element.tags" class="tag"
                                v-bind:style="{'background': t.color}">{{ t.value }}</span>
                        </div>
                      </a>
                    </div>
                  </draggable>
                </div>
                <!-- Possível Churn -->
                <div class="col-xs-12 col-sm-6 col-md-3 box-pipe">
                  <div class="title-box custom-scrollbar">
                    <p>Possível Churn <span>({{ dataList.stage3.length }})</span></p>
                  </div>
                  <draggable :draggable="false" class="list-group" :list="dataList.stage3" group="people"
                             @change="logStage3">
                    <div class="list-group-item" v-for="(element, index) in searchList3" :key="element.id"
                         v-bind:style="{'background': element.color}">
                      <a v-bind:href="'/empresa-detalhes-funil/' + element.pipelineId + '/' + element.id"
                         target="_blank">
                        <p class="company-name" v-bind:title="element.name">{{ element.name | limitTo(30) }}<span><span
                          title="Total de dias no sistema">{{ element.totalDaysCreated }}</span> - <span
                          title="Nome do Proprietário">{{ element.ownerName }}</span></span></p>
                        <p v-if="element.lastUpdated" class="last-update" title="Ultima atualização">
                          {{ element.lastUpdated | dateFunil }}</p>
                        <i v-if="element.hasAcitivty" v-bind:style="element.lastUpdated ? 'top: 40px;' : 'top: 12px;' "
                           class="fa fa-clock-o clock-time" aria-hidden="true">
                          <span class="activityDate" v-if="element.activityDate">
                            {{ element.activityDate }} - </span>
                        </i>
                        <div class="box-tag">
                          <span v-for="t in element.tags" class="tag"
                                v-bind:style="{'background': t.color}">{{ t.value }}</span>
                        </div>
                      </a>
                    </div>
                  </draggable>
                </div>
                <!-- Churn -->
                <div class="col-xs-12 col-sm-6 col-md-3 box-pipe">
                  <div class="title-box custom-scrollbar">
                    <p>Churn <span>({{ dataList.stage4.length }})</span></p>
                  </div>
                  <draggable :draggable="false" class="list-group" :list="dataList.stage4" group="people"
                             @change="logStage4">
                    <div class="list-group-item" v-for="(element, index) in searchList4" :key="element.id"
                         v-bind:style="{'background': element.color}">
                      <a v-bind:href="'/empresa-detalhes-funil/' + element.pipelineId + '/' + element.id"
                         target="_blank">
                        <p class="company-name" v-bind:title="element.name">{{ element.name | limitTo(30) }}<span><span
                          title="Total de dias no sistema">{{ element.totalDaysCreated }}</span> - <span
                          title="Nome do Proprietário">{{ element.ownerName }}</span></span></p>
                        <p v-if="element.lastUpdated" class="last-update" title="Ultima atualização">
                          {{ element.lastUpdated | dateFunil }}</p>
                        <i v-if="element.hasAcitivty" v-bind:style="element.lastUpdated ? 'top: 40px;' : 'top: 12px;' "
                           class="fa fa-clock-o clock-time" aria-hidden="true">
                          <span class="activityDate" v-if="element.activityDate">
                            {{ element.activityDate }} - </span>
                        </i>
                        <div class="box-tag">
                          <span v-for="t in element.tags" class="tag"
                                v-bind:style="{'background': t.color}">{{ t.value }}</span>
                        </div>
                      </a>
                    </div>
                  </draggable>
                </div>
              </div>
            </box-listing>
          </div>
        </div>
      </div>
      <!-- footer-menu -->
      <footer-menu v-if="!loadingList"/>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import footerMenu from "../../components/default/footerMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalHistoryFunil from "../../modals/modalHistoryFunil.vue";
import draggable from 'vuedraggable';
import inputText from "../../components/inputs/inputText.vue";

import {
  GET_LIST_FUNNEL,
  CHANGE_ITEM_FUNNEL,
  GET_PROFILES_CLIENT,
  GET_SELECT_RESPONSIBLES,
  GET_BUSINESS_TASK_TYPES,
  ALL_COMPANY,
  CHANGE_TICKETS_FILTERS, POST_REPORT_CES, POST_REPORT_FUNIL
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import BoxListFilter from "../../components/layouts/boxListFilter.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import BoxDefault from "../../components/layouts/boxDefault.vue";
import BoxListing from "../../components/layouts/boxListing.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputTextarea from "../../components/inputs/inputTextarea.vue";
import InputMultiSelect from "../../components/inputs/inputMultiSelect.vue";
import InputAutocomplete from "../../components/inputs/inputAutocomplete.vue";
import BtnDefault from "../../components/buttons/btnDefault.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";

export default {
  name: "list-funnel",
  components: {
    InputCheckbox,
    BtnSearch,
    BtnDefault,
    InputAutocomplete,
    InputMultiSelect,
    InputTextarea,
    ModalDefault,
    BoxListing,
    BoxDefault,
    InputSelect,
    BoxListFilter,
    BtnCustom,
    draggable,
    topMenu,
    footerMenu,
    pageHeader,
    fullLoading,
    modalHistoryFunil,
    inputText
  },
  data() {
    return {
      listTaskActivities: [
        {
          name: 'Selecione',
          id: ''
        }
      ],
      callCheckRequest: '',
      dataUser: JSON.parse(window.localStorage.getItem('mamUserMasterInfo')),
      loadingList: false,
      failRequest: false,
      dataSend: {
        companyIds: [],
        createdBy: '',
        msg: '',
        businessNoteType: ''
      },
      dataSearch: {
        companyName: '',
        tag: '',
        owner: '',
        profileClient: '',
        getNotactive: 'false',
        isScheduled: 'false',
        taskActivities: '',
        taskStatus: '',
        action: '',
      },
      dataList: {
        stage1: [],
        stage2: [],
        stage3: [],
        stage4: [],
        anotherStage: []
      },
      copyDataList: {
        stage1: [],
        stage2: [],
        stage3: [],
        stage4: [],
      },
      listAction: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Intercom',
          id: 0
        },
        {
          name: 'Ligação',
          id: 1
        },
        {
          name: 'Whatsapp',
          id: 2
        },
        {
          name: 'E-Mail',
          id: 3
        },
        {
          name: 'Msg',
          id: 4
        },
        {
          name: 'Retenção',
          id: 5
        },
        {
          name: 'Onboarding',
          id: 6
        },
        {
          name: 'NPS',
          id: 7
        },
        {
          name: 'Sistema',
          id: 8
        },
        {
          name: 'Financeiro',
          id: 10
        },
        {
          name: 'Possível Churn',
          id: 11
        },
        {
          name: 'FollowUp Automático',
          id: 12
        },
        {
          name: 'Middle',
          id: 18
        },
        {
          name: 'Ongoing',
          id: 19
        },
        {
          name: 'Boas Vindas',
          id: 20
        },
        {
          name: 'Treinamento',
          id: 21
        },
        {
          name: 'Parametrizção',
          id: 22
        },
        {
          name: 'Despedida',
          id: 23
        },
        {
          name: 'Solicitação Cancelamento',
          id: 24
        },
        {
          name: 'Beneflex',
          id: 27
        }
      ],
      listTag: ['Selecione'],
      stages: [],
      selectProfilesClient: ['Selecione'],
      dataSelectResponsibles: ['Selecione'],
      disableCompany: [
        {
          name: 'selecione',
          id: ''
        },
        {
          name: 'Não',
          id: 'false'
        },
        {
          name: 'Sim',
          id: 'true'
        }
      ],
      onlySchedule: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Não',
          id: 'false'
        },
        {
          name: 'Sim',
          id: 'true'
        }
      ],
      statusActivity: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Pendente',
          id: '0'
        },
        {
          name: 'Em andamento',
          id: 1
        },
        {
          name: 'Concluído',
          id: 2
        }
      ],
      listCompany: '',
      listCompanyActive: '',
      loadedCompanies: '',
      showAllCompany: false,
      listItemsSelect: [],
      requestCompanies: false,
      autocompleteContent: '',
      textAreaContent: '',
      massAction: '',
      validateSend: {
        listItemsSelect: false,
        companiesNameList: false,
      },
      loadingSend: false,

    }
  },
  methods: {
    sendMassShipping() {
      if (this.listItemsSelect.length) {
        this.dataSend.companyIds = this.listItemsSelect.map(value => value.id)
      } else {
        return this.validateSend.listItemsSelect = true;
      }

      if (this.massAction || this.massAction === 0) {
        this.dataSend.businessNoteType = this.massAction;
      } else {
        return this.validateSend.companiesNameList = true;
      }

      this.dataSend.createdBy = this.$route.params.userInfo.name;

      if (this.textAreaContent)
        this.dataSend.msg = this.textAreaContent


      this.loadingSend = true;

      const url = POST_REPORT_FUNIL;

      UTIL_SERVICE.console("URL POST_REPORT_FUNIL:", url);
      REQUEST_SERVICE.post(url, this.dataSend).then((response) => {
        UTIL_SERVICE.console("URL POST_REPORT_FUNIL:", response);

        this.loadingSend = false;

        swal("Sucesso!", "Comentario enviado com sucesso.", "success");
        $('#massShipping').modal('hide');

        setTimeout(() => {
          location.reload();
        }, 1500);

      }).catch((reason) => {
        this.loadingSend = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
        $('#massShipping').modal('hide');
      })
    },
    addItems() {
      const selectedItem = {id: Date.now(), name: this.listCompany};
      this.listItemsSelect.push(selectedItem);
      this.autocompleteContent = ''
    },
    removeItem(item) {
      const index = this.listItemsSelect.indexOf(item);
      if (index > -1) {
        this.listItemsSelect.splice(index, 1)
      }

    },
    getCompanies() {
      if (this.requestCompanies === false) {
        REQUEST_SERVICE.get(CHANGE_TICKETS_FILTERS).then((response => {
          UTIL_SERVICE.console("RESULT CHANGE_TICKETS_FILTERS:", response.data);
          this.listCompany = response.data.companies;
          this.listCompanyActive = this.listCompany.filter(company => company.active === true);
          this.loadedCompanies = this.listCompanyActive;
          this.this.requestCompanies = true
        }))
      }
    },
    changeValueListCompany(value) {
      if (value) {
        this.loadedCompanies = this.listCompany;
      } else {
        this.loadedCompanies = this.listCompanyActive;
      }
    },
    openModalMassShipping() {
      this.getCompanies();
      $('#massShipping').modal()
    },
    getBusinessTaskTypes() {
      REQUEST_SERVICE.get(GET_BUSINESS_TASK_TYPES).then((response) => {
        UTIL_SERVICE.console("RESULT GET_BUSINESS_TASK_TYPES:", response.data);
        // this.listTaskActivities = response.data;
        this.listTaskActivities.push(...response.data);

      }).catch((reason) => {
      });
    },
    openHistory() {
      this.callCheckRequest = Math.floor(Math.random() * 500);

      $("#modalHistoryFunil").modal();
    },
    changeItemStage(item, stage) {
      let url = CHANGE_ITEM_FUNNEL;
      url += "?u=" + this.dataUser.id;
      url += "&businessId=" + item.id;
      url += "&pipelineId=" + item.pipelineId;
      url += "&stageId=" + stage;

      UTIL_SERVICE.console("URL Send:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT CHANGE_ITEM_FUNNEL:", response.data);
      }).catch((reason) => {
      });
    },
    logStage1: function (evt) {
      if (typeof evt.added !== "undefined")
        if (evt.added) {
          this.changeItemStage(evt.added.element, 1);
          this.copyDataList.stage1.unshift(evt.added.element);
        }

      if (typeof evt.removed !== "undefined")
        if (evt.removed) {
          this.copyDataList.stage1.map((value, index) => {

            if (value.id === evt.removed.element.id) {
              this.copyDataList.stage1.splice(index, 1);
            }
          });
        }
    },
    logStage2: function (evt) {
      if (typeof evt.added !== "undefined")
        if (evt.added) {
          this.changeItemStage(evt.added.element, 2);
          this.copyDataList.stage2.unshift(evt.added.element);
        }

      if (typeof evt.removed !== "undefined")
        if (evt.removed) {
          this.copyDataList.stage2.map((value, index) => {

            if (value.id === evt.removed.element.id) {
              this.copyDataList.stage2.splice(index, 1);
            }
          });
        }
    },
    logStage3: function (evt) {
      if (typeof evt.added !== "undefined")
        if (evt.added) {
          this.changeItemStage(evt.added.element, 3);
          this.copyDataList.stage3.unshift(evt.added.element);
        }

      if (typeof evt.removed !== "undefined")
        if (evt.removed) {
          this.copyDataList.stage3.map((value, index) => {

            if (value.id === evt.removed.element.id) {
              this.copyDataList.stage3.splice(index, 1);
            }
          });
        }
    },
    logStage4: function (evt) {
      if (typeof evt.added !== "undefined")
        if (evt.added) {
          this.changeItemStage(evt.added.element, 4);
          this.copyDataList.stage4.unshift(evt.added.element);
        }

      if (typeof evt.removed !== "undefined")
        if (evt.removed) {
          this.copyDataList.stage4.map((value, index) => {

            if (value.id === evt.removed.element.id) {
              this.copyDataList.stage4.splice(index, 1);
            }
          });
        }
    },
    listFunnel() {
      this.loadingList = true;
      this.dataList = {
        stage1: [],
        stage2: [],
        stage3: [],
        stage4: []
      };
      this.copyDataList = {
        stage1: [],
        stage2: [],
        stage3: [],
        stage4: []
      };

      let url = GET_LIST_FUNNEL;
      url += "?u=" + this.dataUser.id;
      url += "&pipelineId=1";
      url += "&getNotactive=" + this.dataSearch.getNotactive;

      if (this.dataSearch.companyName)
        url += "&companyName=" + this.dataSearch.companyName;

      if (this.dataSearch.tag) {
        url += "&tagName=" + this.dataSearch.tag;
      }

      if (this.dataSearch.owner)
        url += "&ownerName=" + this.dataSearch.owner;

      if (this.dataSearch.profileClient)
        url += "&profileClient=" + this.dataSearch.profileClient;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_LIST_FUNNEL:", response.data);

        this.stages = response.data.stages;

        if (response.data.tagsWithoutProfileClient) {
          const formattedArray = response.data.tagsWithoutProfileClient.map((value) => (value.value));
          this.listTag.push(...formattedArray)
        }

        response.data.companies.map((value, index) => {
          switch (value.stageId) {
            case 1:
              this.dataList.stage1.push(value);
              this.copyDataList.stage1.push(value);
              break;
            case 2:
              this.dataList.stage2.push(value);
              this.copyDataList.stage2.push(value);
              break;
            case 3:
              this.dataList.stage3.push(value);
              this.copyDataList.stage3.push(value);
              break;
            case 4:
              this.dataList.stage4.push(value);
              this.copyDataList.stage4.push(value);
              break;
            default:
              this.dataList.anotherStage.push(value);
              this.copyDataList.anotherStage.push(value);
              break
          }
        });

        this.loadingList = false;
      }).catch((reason) => {
        this.failRequest = true;
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    getProfileClient() {

      REQUEST_SERVICE.get(GET_PROFILES_CLIENT).then((response) => {
        UTIL_SERVICE.console("RESULT GET_PROFILES_CLIENT:", response.data);

        this.selectProfilesClient.push(...response.data)

      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    searchFunnel() {
      if (this.dataSearch.getNotactive === "true") {
        this.listFunnel();
      }
    },
    searchInMemory(index) {
      let dataCopy = null;
      let dataReturn = null;

      switch (index) {
        case 1:
          this.dataList.stage1 = [];
          dataCopy = this.copyDataList.stage1;
          break;
        case 2:
          this.dataList.stage2 = [];
          dataCopy = this.copyDataList.stage2;
          break;
        case 3:
          this.dataList.stage3 = [];
          dataCopy = this.copyDataList.stage3;
          break;
        case 4:
          this.dataList.stage4 = [];
          dataCopy = this.copyDataList.stage4;
          break;
      }

      dataReturn = dataCopy.filter((value => {
        if (this.dataSearch.companyName) {
          // Search by company name
          let filterByName = value.name.toLowerCase().match(this.dataSearch.companyName.toLowerCase());

          // Search by owner
          if (this.dataSearch.owner && value.ownerName)
            if (!value.ownerName.toLowerCase().includes(this.dataSearch.owner.toLowerCase())) {
              filterByName = null;
            }
          // else
          //     filterByName = null;

          // Search by activity
          if (this.dataSearch.isScheduled === "true" && value.hasAcitivty)
            if (!value.hasAcitivty.toString().match(this.dataSearch.isScheduled)) {
              filterByName = null;
            } else
              filterByName = null;

          // Search by tag
          if (this.dataSearch.tag) {
            // if (filterByName.tags.length) {
            //   let searchTag = filterByName.tags.filter((tag => {
            //     return tag.value.toLowerCase().match(this.dataSearch.tag.toLowerCase())
            //   }));
            //
            //   if (searchTag.length) {
            //   }
            // }
          } else {
            return filterByName
          }
        } else if (this.dataSearch.tag) {
          return value
        } else if (this.dataSearch.profileClient) {
          return value
        } else if (this.dataSearch.owner) {
          return value
        } else if (this.dataSearch.isScheduled === "true") {
          return value
        } else if (this.dataSearch.taskActivities) {
          return value
        } else if (this.dataSearch.taskStatus) {
          return value
        } else {
          return value
        }
      }));

      switch (index) {
        case 1:
          return dataReturn;
          break;
        case 2:
          return dataReturn;
          break;
        case 3:
          return dataReturn;
          break;
        case 4:
          return dataReturn;
          break;
      }
    },
    getSelectResponsibles() {
      REQUEST_SERVICE.get(GET_SELECT_RESPONSIBLES).then((response) => {
        UTIL_SERVICE.console("RESULT GET_SELECT_RESPONSIBLES:", response.data);

        this.dataSelectResponsibles.push(...response.data)

      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
  },
  beforeMount() {
    this.listFunnel();
    this.getProfileClient();
    this.getSelectResponsibles();
    this.getBusinessTaskTypes();
  },
  computed: {
    searchList1: function () {
      let dataCopy = null;
      let dataReturn = null;

      switch (1) {
        case 1:
          this.dataList.stage1 = [];
          dataCopy = this.copyDataList.stage1;
          break;
        case 2:
          this.dataList.stage2 = [];
          dataCopy = this.copyDataList.stage2;
          break;
        case 3:
          this.dataList.stage3 = [];
          dataCopy = this.copyDataList.stage3;
          break;
        case 4:
          this.dataList.stage4 = [];
          dataCopy = this.copyDataList.stage4;
          break;
      }

      this.dataList.stage1 = dataCopy.filter((value => {
        let dataFilter = value;

        if (this.dataSearch.tag === 'Selecione') {
          this.dataSearch.tag = ''
        }

        // Search by company name
        if (this.dataSearch.companyName) {
          if (dataFilter.name) {
            if (!dataFilter.name.toLowerCase().includes(this.dataSearch.companyName.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by owner
        else if (this.dataSearch.owner) {
          if (value.ownerName) {
            if (!value.ownerName.toLowerCase().includes(this.dataSearch.owner.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by activity
        else if (this.dataSearch.isScheduled === "true") {
          if (!value.hasAcitivty.toString().match(this.dataSearch.isScheduled)) {
            dataFilter = null;
          } else {
            return dataFilter
          }
        }

        // Search by activity name
        else if (this.dataSearch.taskActivities || this.dataSearch.taskStatus) {
          if (dataFilter) {
            if (dataFilter.listTasks.length) {
              let searchTasks = ''

              if (this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                let valueTaskType = dataFilter.listTasks.some(a => a.businessTaskType.toString() == this.dataSearch.taskActivities.toString())
                let valueTaskStatus = dataFilter.listTasks.some(a => a.businessTaskStatus.toString() == this.dataSearch.taskStatus.toString())

                return valueTaskType && valueTaskStatus
              }

              if (this.dataSearch.taskActivities && !this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskType.toString().match(this.dataSearch.taskActivities.toString()) != null;
                }))
              }

              if (!this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskStatus.toString().match(this.dataSearch.taskStatus.toString()) != null;
                }))
              }

              if (searchTasks.length) {
                return searchTasks
              }
            } else {
              return null
            }
          }
        }

        // Search by tag
        else if (this.dataSearch.tag || this.dataSearch.profileClient) {
          if (dataFilter) {
            if (dataFilter.tags.length) {

              let searchTag = ''

              if (this.dataSearch.tag && this.dataSearch.profileClient) {
                let valueTag = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.tag.toLowerCase())
                let valueProfuleClient = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.profileClient.toLowerCase())

                return valueTag && valueProfuleClient
              }

              if (this.dataSearch.tag && !this.dataSearch.profileClient) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.tag.toLowerCase()) != null;
                }))
              }

              if (this.dataSearch.profileClient && !this.dataSearch.tag) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.profileClient.toLowerCase()) != null;
                }))
              }

              if (searchTag.length) {
                return searchTag
              }
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return dataFilter
        }
      }));

      return this.dataList.stage1;
    },
    searchList2: function () {
      let dataCopy = null;
      let dataReturn = null;

      switch (2) {
        case 1:
          this.dataList.stage1 = [];
          dataCopy = this.copyDataList.stage1;
          break;
        case 2:
          this.dataList.stage2 = [];
          dataCopy = this.copyDataList.stage2;
          break;
        case 3:
          this.dataList.stage3 = [];
          dataCopy = this.copyDataList.stage3;
          break;
        case 4:
          this.dataList.stage4 = [];
          dataCopy = this.copyDataList.stage4;
          break;
      }

      this.dataList.stage2 = dataCopy.filter((value => {
        let dataFilter = value;

        if (this.dataSearch.tag === 'Selecione') {
          this.dataSearch.tag = ''
        }

        // Search by company name
        if (this.dataSearch.companyName) {
          if (dataFilter.name) {
            if (!dataFilter.name.toLowerCase().includes(this.dataSearch.companyName.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by owner
        else if (this.dataSearch.owner) {
          if (value.ownerName) {
            if (!value.ownerName.toLowerCase().includes(this.dataSearch.owner.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by activity
        else if (this.dataSearch.isScheduled === "true") {
          if (!value.hasAcitivty.toString().match(this.dataSearch.isScheduled)) {
            dataFilter = null;
          } else {
            return dataFilter
          }
        }

        // Search by activity name
        else if (this.dataSearch.taskActivities || this.dataSearch.taskStatus) {
          if (dataFilter) {
            if (dataFilter.listTasks.length) {
              let searchTasks = ''

              if (this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                let valueTaskType = dataFilter.listTasks.some(a => a.businessTaskType.toString() == this.dataSearch.taskActivities.toString())
                let valueTaskStatus = dataFilter.listTasks.some(a => a.businessTaskStatus.toString() == this.dataSearch.taskStatus.toString())

                return valueTaskType && valueTaskStatus
              }

              if (this.dataSearch.taskActivities && !this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskType.toString().match(this.dataSearch.taskActivities.toString()) != null;
                }))
              }

              if (!this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskStatus.toString().match(this.dataSearch.taskStatus.toString()) != null;
                }))
              }

              if (searchTasks.length) {
                return searchTasks
              }
            } else {
              return null
            }
          }
        }

        // Search by tag
        else if (this.dataSearch.tag || this.dataSearch.profileClient) {
          if (dataFilter) {
            if (dataFilter.tags.length) {

              let searchTag = ''

              if (this.dataSearch.tag && this.dataSearch.profileClient) {
                let valueTag = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.tag.toLowerCase())
                let valueProfuleClient = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.profileClient.toLowerCase())

                return valueTag && valueProfuleClient
              }

              if (this.dataSearch.tag && !this.dataSearch.profileClient) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.tag.toLowerCase()) != null;
                }))
              }

              if (this.dataSearch.profileClient && !this.dataSearch.tag) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.profileClient.toLowerCase()) != null;
                }))
              }

              if (searchTag.length) {
                return searchTag
              }
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return dataFilter
        }
      }));

      return this.dataList.stage2;
    },
    searchList3: function () {
      let dataCopy = null;
      let dataReturn = null;

      switch (3) {
        case 1:
          this.dataList.stage1 = [];
          dataCopy = this.copyDataList.stage1;
          break;
        case 2:
          this.dataList.stage2 = [];
          dataCopy = this.copyDataList.stage2;
          break;
        case 3:
          this.dataList.stage3 = [];
          dataCopy = this.copyDataList.stage3;
          break;
        case 4:
          this.dataList.stage4 = [];
          dataCopy = this.copyDataList.stage4;
          break;
      }

      this.dataList.stage3 = dataCopy.filter((value => {
        let dataFilter = value;

        if (this.dataSearch.tag === 'Selecione') {
          this.dataSearch.tag = ''
        }

        // Search by company name
        if (this.dataSearch.companyName) {
          if (dataFilter.name) {
            if (!dataFilter.name.toLowerCase().includes(this.dataSearch.companyName.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by owner
        else if (this.dataSearch.owner) {
          if (value.ownerName) {
            if (!value.ownerName.toLowerCase().includes(this.dataSearch.owner.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by activity
        else if (this.dataSearch.isScheduled === "true") {
          if (!value.hasAcitivty.toString().match(this.dataSearch.isScheduled)) {
            dataFilter = null;
          } else {
            return dataFilter
          }
        }

        // Search by activity name
        else if (this.dataSearch.taskActivities || this.dataSearch.taskStatus) {
          if (dataFilter) {
            if (dataFilter.listTasks.length) {
              let searchTasks = ''

              if (this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                let valueTaskType = dataFilter.listTasks.some(a => a.businessTaskType.toString() == this.dataSearch.taskActivities.toString())
                let valueTaskStatus = dataFilter.listTasks.some(a => a.businessTaskStatus.toString() == this.dataSearch.taskStatus.toString())

                return valueTaskType && valueTaskStatus
              }

              if (this.dataSearch.taskActivities && !this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskType.toString().match(this.dataSearch.taskActivities.toString()) != null;
                }))
              }

              if (!this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskStatus.toString().match(this.dataSearch.taskStatus.toString()) != null;
                }))
              }

              if (searchTasks.length) {
                return searchTasks
              }
            } else {
              return null
            }
          }
        }

        // Search by tag
        else if (this.dataSearch.tag || this.dataSearch.profileClient) {
          if (dataFilter) {
            if (dataFilter.tags.length) {

              let searchTag = ''

              if (this.dataSearch.tag && this.dataSearch.profileClient) {
                let valueTag = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.tag.toLowerCase())
                let valueProfuleClient = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.profileClient.toLowerCase())

                return valueTag && valueProfuleClient
              }

              if (this.dataSearch.tag && !this.dataSearch.profileClient) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.tag.toLowerCase()) != null;
                }))
              }

              if (this.dataSearch.profileClient && !this.dataSearch.tag) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.profileClient.toLowerCase()) != null;
                }))
              }

              if (searchTag.length) {
                return searchTag
              }
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return dataFilter
        }
      }));

      return this.dataList.stage3;
    },
    searchList4: function (e) {
      let dataCopy = null;
      let dataReturn = null;

      switch (4) {
        case 1:
          this.dataList.stage1 = [];
          dataCopy = this.copyDataList.stage1;
          break;
        case 2:
          this.dataList.stage2 = [];
          dataCopy = this.copyDataList.stage2;
          break;
        case 3:
          this.dataList.stage3 = [];
          dataCopy = this.copyDataList.stage3;
          break;
        case 4:
          this.dataList.stage4 = [];
          dataCopy = this.copyDataList.stage4;
          break;
      }

      this.dataList.stage4 = dataCopy.filter((value => {
        let dataFilter = value;

        if (this.dataSearch.tag === 'Selecione') {
          this.dataSearch.tag = ''
        }

        // Search by company name
        if (this.dataSearch.companyName) {
          if (dataFilter.name) {
            if (!dataFilter.name.toLowerCase().includes(this.dataSearch.companyName.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by owner
        else if (this.dataSearch.owner) {
          if (value.ownerName) {
            if (!value.ownerName.toLowerCase().includes(this.dataSearch.owner.toLowerCase())) {
              dataFilter = null;
            } else {
              return dataFilter
            }
          } else {
            dataFilter = null;
          }
        }

        // Search by activity
        else if (this.dataSearch.isScheduled === "true") {
          if (!value.hasAcitivty.toString().match(this.dataSearch.isScheduled)) {
            dataFilter = null;
          } else {
            return dataFilter
          }
        }

        // Search by activity name
        else if (this.dataSearch.taskActivities || this.dataSearch.taskStatus) {
          if (dataFilter) {
            if (dataFilter.listTasks.length) {
              let searchTasks = ''

              if (this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                let valueTaskType = dataFilter.listTasks.some(a => a.businessTaskType.toString() == this.dataSearch.taskActivities.toString())
                let valueTaskStatus = dataFilter.listTasks.some(a => a.businessTaskStatus.toString() == this.dataSearch.taskStatus.toString())

                return valueTaskType && valueTaskStatus
              }

              if (this.dataSearch.taskActivities && !this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskType.toString().match(this.dataSearch.taskActivities.toString()) != null;
                }))
              }

              if (!this.dataSearch.taskActivities && this.dataSearch.taskStatus) {
                searchTasks = dataFilter.listTasks.filter((tasks => {
                  return tasks.businessTaskStatus.toString().match(this.dataSearch.taskStatus.toString()) != null;
                }))
              }

              if (searchTasks.length) {
                return searchTasks
              }
            } else {
              return null
            }
          }
        }

        // Search by tag
        else if (this.dataSearch.tag || this.dataSearch.profileClient) {
          if (dataFilter) {
            if (dataFilter.tags.length) {

              let searchTag = ''

              if (this.dataSearch.tag && this.dataSearch.profileClient) {
                let valueTag = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.tag.toLowerCase())
                let valueProfuleClient = dataFilter.tags.some(a => a.value.toLowerCase() == this.dataSearch.profileClient.toLowerCase())

                return valueTag && valueProfuleClient
              }

              if (this.dataSearch.tag && !this.dataSearch.profileClient) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.tag.toLowerCase()) != null;
                }))
              }

              if (this.dataSearch.profileClient && !this.dataSearch.tag) {
                searchTag = dataFilter.tags.filter((tag => {
                  return tag.value.toLowerCase().match(this.dataSearch.profileClient.toLowerCase()) != null;
                }))
              }

              if (searchTag.length) {
                return searchTag
              }
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return dataFilter
        }
      }));

      return this.dataList.stage4;
    }
  },
  watch: {
    autocompleteContent(newValue, oldValue) {
      this.listItemsSelect.push(newValue);
    },
    listItemsSelect() {
      if (this.listItemsSelect.length && this.validateSend.listItemsSelect === true) {
        this.validateSend.listItemsSelect = false;
      }
    },
    showAllCompany(newValue, oldValue) {
      this.changeValueListCompany(newValue);
    }
  }
}
</script>

<style lang="scss">
.custom-checkbox {
  label {
    input {
      z-index: 0 !important;
    }
  }
}

.remove-item {
  &:hover {
    background: #E6445D;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background: #FF445D;
  color: #FFF;
  border: none;
  font-size: 12px;
  margin-left: 20px;
  border-radius: 50% !important;
  position: relative;

  ion-icon {
    color: #FFF;
    position: absolute;
  }
}

.items-list {
  display: flex;
  align-items: center;
  max-width: max-content;
  background: #E6E9EC;
  border-radius: 4px !important;
  padding: 1px 8px 2px 8px;
  margin-bottom: 10px;
}

.list-company {
  display: flex;
  flex-wrap: wrap;
  gap: 4%;
}

.custom-scrollbar {
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #9C9797;
    border: 0 solid #9C9797;
  }
}

.activityDate {
  font-size: 11px;
  float: left;
  margin-right: 5px;
}

.default-box {
  .change-history {
    p {
      direction: rtl;
      margin-bottom: 30px;
      margin-top: 0;
      font-size: 16px;

      a {
        color: #333;

        &:hover {
          text-decoration: none;
          border-bottom: 1px solid #333;
          padding-bottom: 2px;
        }
      }
    }
  }

  .box-pipe {

    .title-box {
      position: relative;

      p {
        direction: ltr;
        font-size: 20px;
        border: 1px solid #E6E9EC;
        padding: 8px;
        margin: 0;
        color: #333;
        border-top-left-radius: 4px !important;
        border-top-right-radius: 4px !important;

        span {
          float: right;
          font-size: 18px;
        }
      }
    }

    .list-group {
      direction: rtl;
      background: #E6E9EC85;
      position: relative;
      overflow: auto;
      height: 800px;

      .list-group-item {
        min-height: 80px;
      }

      a {
        color: #333333;
        cursor: pointer;
        direction: ltr;

        .company-name {
          display: block;
          font-weight: 600;
          margin-top: 0;
          font-size: 15px;
          padding-bottom: 2px;
          margin-bottom: 5px;
          padding-right: 80px;
          word-wrap: break-word;

          span {
            font-size: 12px;
            font-weight: normal;
            display: block;

            span {
              display: inline-block;
            }
          }
        }

        .last-update {
          position: absolute;
          top: -10px;
          font-size: 12px;
          border: 1px solid #C1C1C1;
          padding: 2px 10px;
          border-radius: 4px !important;
        }

        .clock-time {
          position: absolute;
          font-size: 19px;
          top: 40px;
          margin-top: 10px;
        }

        .box-tag {
          margin-top: 24px;
          position: relative;
          display: block;

          .tag {
            background: #97999B;
            color: #FFF;
            padding: 3px 14px;
            border-radius: 4px !important;
            font-size: 12px;
            display: inline-block;
            margin-right: 10px;
            margin-bottom: 5px;
          }
        }

        &:hover {
          color: #333333;
          text-decoration: none;
        }
      }
    }
  }
}

.swal-overlay {
  z-index: 11000;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/funnel/listFunnel.vue